exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3msGn5_6iOGBdgkJ1nNWOI{padding:20px 0px}._1knEIAPEhq5UEBDY0MaGhW{padding-top:15px;display:flex;justify-content:space-between}._1ZCzDt09IegucEc7yCsafo{font-weight:500;line-height:20px;max-width:295px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}._1ZCzDt09IegucEc7yCsafo a,._1ZCzDt09IegucEc7yCsafo a:visited{color:inherit;text-decoration:none}._1ZCzDt09IegucEc7yCsafo a:hover{color:#fa6400}._39vkXsKn_ww-uHMhpfiIca{margin-top:3px;color:#757575;font-size:13px;line-height:20px}._39vkXsKn_ww-uHMhpfiIca span{display:inline-block;margin-right:10px}\n", ""]);

// Exports
exports.locals = {
	"NavigationInfo": "_3msGn5_6iOGBdgkJ1nNWOI",
	"container": "_1knEIAPEhq5UEBDY0MaGhW",
	"navItemName": "_1ZCzDt09IegucEc7yCsafo",
	"navItemMetrics": "_39vkXsKn_ww-uHMhpfiIca"
};